<template>
    <MainContainer :container="!xs" background="lightGrey" :footer="false" :style="[addPaddingBottom ? {'padding-bottom': '80px'} : '']">
        <template slot="header">
            <HeadingBar v-if="heading !== null" :heading="heading" />
        </template>
        <slot></slot>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import HeadingBar from '@/components/controls/HeadingBar.vue';

export default {
    components: {
        MainContainer,
        HeadingBar
    },
    props: {
        heading: {
            type: String
        },
        addPaddingBottom: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
